// extracted by mini-css-extract-plugin
export default {"cont1":"CardDetail_cont1__JSCsu"};